import React from 'react';
import { dateToLabel, numberToDisplayString } from 'further-ui/utils';
import { Control, Controller } from 'react-hook-form';
import { realisation as rules } from 'further-ui/validations';
import { AppNumberInput } from 'components/FormElements';
import Table, { Column } from 'components/Table';
import { Box, styled } from '@mui/material';

type RowType = {
  investmentId: string;
  date: Date;
  currentNumberOfUnits: number;
  allocatedUnits?: number;
};

type UnitToInvestmentAllocationTableProps = {
  unitsAllocationPerInvestment: Array<RowType>;
  onManualAllocationChange: () => void;
  control: Control<rules.CreateRealisationFormValues>;
  index: number;
  clearConsiderationForm: () => void;
};

const StyledTableWrapper = styled(Box)(() => ({
  '.Cmt-table-responsive': {
    border: '1px solid #ebebec',
    borderRadius: '8px',
  },
}));

const UnitToInvestmentAllocationTable: React.FC<
  UnitToInvestmentAllocationTableProps
> = ({
  unitsAllocationPerInvestment,
  control,
  index,
  onManualAllocationChange,
  clearConsiderationForm,
}) => {
  const renderAllocationInput = (rowIndex: number) => (
    <Controller
      control={control}
      name={`holdingClassRealisation.${index}.unitsAllocationPerInvestment.${rowIndex}.allocatedUnits`}
      render={({ field }) => (
        <AppNumberInput
          value={Number(field.value)}
          onChange={(value) => {
            field.onChange(value);
            clearConsiderationForm();
            onManualAllocationChange();
          }}
          name={field.name}
          decimals={2}
          fullWidth
          zeroAsPlaceholder
        />
      )}
    />
  );

  const columns: Array<Column<RowType>> = [
    {
      key: 'date',
      label: 'Investment Date',
      render: (row) => dateToLabel(row.date),
    },
    {
      key: 'currentNumberOfUnits',
      label: 'Units Held',
      render: (row) => numberToDisplayString(row.currentNumberOfUnits),
    },
    {
      key: 'allocatedUnits',
      label: 'Units Realised',
      render: (_, rowIndex) => renderAllocationInput(rowIndex),
    },
  ];

  const rows = unitsAllocationPerInvestment.map((investment, index) => ({
    ...investment,
    id: investment.investmentId || `investment-${index}`,
  }));

  return (
    <StyledTableWrapper>
      <Table
        columns={columns}
        tablebody={rows}
        key={`holding-class-${index}`}
      />
    </StyledTableWrapper>
  );
};

export default UnitToInvestmentAllocationTable;
